import React from 'react';
import { useSelector } from 'react-redux';
import './NonCalendarUser.scss';
import Progress from '../shared/Progress';

export const NonCalendarUser = () => {
  const isLoading = useSelector((state) => state.app.isLoading);
  const delegateError = useSelector((state) => state.calendar.delegateError);
  return (
    <div className={'nonCalendarUser-container'}>
      { isLoading ? <Progress /> :
      delegateError ?
        <>
          <div className='nonCalendarUser-content'>
            <p className='nonCalendarUser-heading'>The Calendar owner is not a Calendar User.</p>
            <p className='nonCalendarUser-paragraph'>Make sure they log into the add-in, or contact your Admin to resolve.</p>
          </div>
        </> :
        <>
          <div className='nonCalendarUser-content'>
            <p className='nonCalendarUser-heading'>Calendar for Docrio Email <br/>is not enabled for your current user.</p>
            <p className='nonCalendarUser-paragraph'>Contact your Admin to enable Calendar for Docrio Email.</p>
          </div>
        </>
      }
    </div>
  );
};
